import { Box, BoxProps } from "@mui/material";

/**
 * A plain dashed-border square, standing in for content that hasn't been
 * created/selected yet (design D9's zero-result states; the picker's own
 * empty cart uses a similar dashed-slot motif elsewhere in this app).
 *
 * There's no dedicated empty-state icon/illustration convention anywhere
 * in the codebase yet — this is deliberately simple (no SVG asset) so it's
 * easy to reuse: pass `size` for scale, `borderWidth` for weight (a larger
 * icon reads better with a slightly bolder border), or `sx` for one-off
 * overrides.
 */
export function EmptyStateIcon({
  size = 30,
  borderWidth = 1.5,
  color = "grey.400",
  sx,
}: {
  size?: number;
  borderWidth?: number;
  /** A theme path (e.g. `"primary.main"`, `"grey.400"`) or any CSS color. */
  color?: string;
  sx?: BoxProps["sx"];
}) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        border: `${borderWidth}px dashed`,
        borderColor: color,
        borderRadius: "5px",
        ...sx,
      }}
    />
  );
}
